import { Routes, Route } from 'react-router-dom'

import DealersRouter from 'routers/DealersRouter'

import AddFeatureTour from 'pages/AddFeatureTour'
import AddSiteMessage from 'pages/AddSiteMessage'
import AddDeviceMetric from 'pages/AddDeviceMetric'
import EditDeviceMetric from 'pages/EditDeviceMetric'
import EditFeatureTour from 'pages/EditFeatureTour'
import EditSiteMessage from 'pages/EditSiteMessage'
import AlertNotificationConfigurations from 'pages/AlertNotificationConfigurations'
import SiteMessages from 'pages/SiteMessages'
import AddGroupMetric from 'pages/AddGroupMetrics'
import TransferDevice from 'pages/DeviceSearch/TransferDevice'
import ResourceAdmin from 'pages/ResourceAdmin'
import EditGroupMetric from 'pages/EditGroupMetric'
import AddTrend from 'pages/AddTrend'
import EditTrend from 'pages/EditTrend'
import MaintenanceTrends from 'pages/MaintenanceTrends'
import NotFound from 'pages/NotFound'
import PremiumFeatures from 'pages/PremiumFeatures'

const AdminRouter = () => {
  return (
    <Routes>
      <Route path={'dealers/*'} element={<DealersRouter />} />
      <Route path={'device/:deviceId/dealer/:dealerId/transfer'} element={<TransferDevice />} />
      <Route path={'alert_notification_configurations'} element={<AlertNotificationConfigurations />} />
      <Route path={'site_messages/:id/edit'} element={<EditSiteMessage />} />
      <Route path={'site_messages'} element={<SiteMessages />} />
      <Route path={'site_messages/new'} element={<AddSiteMessage />} />
      <Route path={'device_metrics'} element={<MaintenanceTrends />} />
      <Route path={'device_metrics/new'} element={<AddDeviceMetric />} />
      <Route path={'device_metrics/:id/edit'} element={<EditDeviceMetric />} />
      <Route path={'group/new'} element={<AddGroupMetric />} />
      <Route path={'groups/:id/edit'} element={<EditGroupMetric />} />
      <Route path={'trends/new'} element={<AddTrend />} />
      <Route path={'trends/:id/edit'} element={<EditTrend />} />
      <Route path={'groups'} element={<MaintenanceTrends />} />
      <Route path={'trends'} element={<MaintenanceTrends />} />
      <Route path={'feature_tours/:id/edit'} element={<EditFeatureTour />} />
      <Route path={'feature_tours/new'} element={<AddFeatureTour />} />
      <Route path={'feature_tours'} element={<SiteMessages />} />
      <Route path={'resources'} element={<ResourceAdmin />} />
      <Route path={'premium_features'} element={<PremiumFeatures />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AdminRouter
